import React from "react";
import "components/Tribe/Friends/UserDetail/FriendNewsfeed/Reaction.css";
import AddReactionButton from "components/Tribe/Friends/UserDetail/FriendNewsfeed/AddReactionButton";
import UserReaction from "components/Tribe/Friends/UserDetail/FriendNewsfeed/UserReaction";
import ReactionSelectGrid from "components/Tribe/Friends/UserDetail/FriendNewsfeed/ReactionSelectGrid";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import AxiosConfig from "axiosConfig";

class ReactionContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
      reactionList: this.props.reactionList,
      postId: this.props.postId,
    };
  }

  componentDidMount() {}

  handleImageClick(reactionId, reactionImage) {
    //POST a new reaction to this post
    let formData = new FormData();
    formData.append("reaction", reactionId);
    formData.append("post", this.state.postId);
    AxiosConfig.post("posts/reaction/", formData);

    //add the new reaction to this state to trigger a render
    let newReactionList = this.state.reactionList;
    let newReaction = {
      reaction: {
        id: reactionId,
        image: reactionImage,
        username: "",
      },
    };
    newReaction["username"] = this.props.username;
    for (let index = 0; index < newReactionList.length && index >= 0; index++) {
      if (newReactionList[index].username === newReaction["username"]) {
        if (index > -1) {
          newReactionList.splice(index, 1);
          index = index - 2;
        }
      }
    }
    //push onto the new reaction list
    newReactionList.push(newReaction);
    //update the state to trigger re render of user reactions
    this.setState({ reactionList: newReactionList });
    //close the popup
    this.handleLikeClick();
  }

  handleLikeClick() {
    if (this.state.tooltipOpen === true) {
      this.setState({ tooltipOpen: false });
    } else if (this.state.tooltipOpen === false) {
      this.setState({ tooltipOpen: true });
    }
  }

  renderUserReactions(userReactionList) {
    var allReactions = this.props.allReactionImages;

    var allUserReactions = [];
    var userList = [];

    //loop through all user reactions of this post and group
    //like reactions while tallying up all the users who made that same reaction
    for (let reaction of allReactions) {
      for (let userReaction of userReactionList) {
        if (userReaction.reaction["id"] === reaction["id"]) {
          userList.push(userReaction["username"]);
        }
      }
      if (userList.length !== 0) {
        //construct object made up of userList, reactionImage and count
        let userReactionObject = {
          reactionId: reaction["id"],
          users: [],
          reactionImage: reaction["image"],
          count: userList.length,
        };
        //add each user to the object users array
        for (let user of userList) {
          userReactionObject.users.push(user + " ");
        }
        //clear userList
        userList = [];
        //add this object to the allUserReaction list
        allUserReactions.push(userReactionObject);
      }
    }

    //Now use the list to render reactions on this post
    return (
      <div className="user_reaction_columns">
        {allUserReactions.map((elem) => (
          <UserReaction
            count={elem.count}
            image={elem.reactionImage}
            userList={elem.users}
            key={elem.reactionId}
          />
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className="reaction_container">
        {this.state.tooltipOpen ? (
          <ClickAwayListener onClickAway={this.handleLikeClick.bind(this)}>
            <ReactionSelectGrid
              reactions={this.props.allReactionImages}
              onImageClick={this.handleImageClick.bind(this)}
            />
          </ClickAwayListener>
        ) : null}
        <AddReactionButton onClick={this.handleLikeClick.bind(this)} />

        {this.renderUserReactions(this.state.reactionList)}
      </div>
    );
  }
}

export default ReactionContainer;
